import React, { useEffect, useState } from "react";
import AdminNavBarMain from "./AdminNavBarMain";
import * as XLSX from "xlsx";
import Skeleton from "react-loading-skeleton";
import InputGroup from "react-bootstrap/InputGroup";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {
  base_url,
  STATUS_IN_PROGRESS,
  STATUS_APPROVED,
  STATUS_REJECTED,
  STATUS_PROCESSED,
  STATUS_CLOSED,
  LOAN_CURRENCY_TYPE_BHD,
  LOAN_CURRENCY_TYPE_USD,
  STATUS_NEW,
  AUDITOR_ROLE,
  LOAN_DELISTED,
  LOAN_TECHNICAL_CLOSURE,
} from "./../utilities";
import FileSaver from "file-saver";
import Table from "react-bootstrap/Table";
import { useNavigate } from "react-router-dom";
import axios from ".././axios-interceptor";
import TableData from "./TableData";
import { Form, Modal } from "react-bootstrap";
import moment from "moment";
import { toast } from "react-toastify";
import NewInvDetailedView from "./NewInvDetailedView";
import FundNowLoanRows from "./FundNowLoanRows";
import { decrypt } from "../utils";
import Cookies from 'js-cookie';

const AdminInvestors = (props) => {
  let ltwo = props.loading;
  const [loading, setLoading] = useState(true);
  const [modalLoanDetailsShow, setModalLoanDetailsShow] = useState(false);
  const [defaultvalue, setDefaultValue] = useState(false);
  const [allInvestorsCount, setAllInvestorCount] = useState();
  const [totalInvestment, setTotalInvestmentInDinar] = useState();
  const [totalInvestmentDolor, setTotalInvestmentInDolor] = useState();
  const [allInvestorsInvestCount, setAllInvestorInvestCount] = useState();
  const [totalInvestmentInvest, setTotalInvestmentInvestInDinar] = useState();
  const [totalInvestmentDolorInvest, setTotalInvestmentInvestInDolor] =
    useState();
  const [invInterestData, setInvInterestData] = useState([]);
  const [invInterestFilter, setInvInterestFilter] = useState([]);
  // const [newInvestInterestFilter, setNewInvestInterestFilter] = useState([]);
  const [newInvestInterest, setNewInvestInterest] = useState([]);
  let count = invInterestFilter.length;
  const [sortOrder, setSortOrder] = useState({ column: null, direction: null });
  const [firstValue, setFirstValue] = useState([]);
  const [secondValue, setSecondValue] = useState([]);
  const [thirdValue, setThirdValue] = useState([]);
  const [fourthValue, setFourthValue] = useState([]);
  const[displayedData,setDisplayedData]=useState([]);
  const handleChangeAllInput=(e)=>{
    const value = e.target.value;
if(value.length>3)
{
  axios
      .post(base_url+'investor-master/get_investor_master',{filter_value:value})
      .then((res)=>{
        let data=res.data.data;
        if (data && data.length > 0) {
          setInvInterestFilter(data);
          setFourthValue(data);
          setFirstValue(data);
          setSecondValue(data);
          setThirdValue(data);
        }
      })
      .catch((err)=>{
        console.log(err,"error");
      })
}
if(value.length===0)
{
  setInvInterestFilter(displayedData);
}
  }

  const handleChangeAllInputInterests=(e)=>{
    const value = e.target.value;
    setInterestSearch(value.length > 3 ? value : "");
if(value.length>3)
{
  axios
      .post(base_url+'investor-interests/get_investment_interests',{filter_value:value})
      .then((res)=>{
        let data=res.data.data;
        if (data && data.length > 0) {
          setNewInvestInterest(data);
          setFourthValue(data);
          setFirstValue(data);
          setSecondValue(data);
          setThirdValue(data);
        }
      })
      .catch((err)=>{
        console.log(err,"error");
      })
}
if(value.length===0)
{

  axios
      .post(base_url+'investor-interests/get_investment_interests')
      .then((res)=>{
        let data=res.data.data;
        if (data && data.length > 0) {
          setNewInvestInterest(data);
          setFourthValue(data);
          setFirstValue(data);
          setSecondValue(data);
          setThirdValue(data);
        }
      })
      .catch((err)=>{
        console.log(err,"error");
      })
}
  }

  useEffect(() => {
    
    Cookies.remove("investor_loan_id");
    if (!Cookies.get("User_Accesstoken_Admin")) {
      navigate("/adminlogin");
    }
    if (Cookies.get("is_first_tab") == "false") {
      document.getElementById("investors-tab").classList.remove("active");
      document.getElementById("newinvestment-tab").classList.add("active");
      document.getElementById("investors-tab-pane").classList.remove("active");
      document.getElementById("newinvestment-tab-pane").classList.add("active");
      setDefaultValueForInvestor(true);
    } else {
      setDefaultValueForInvestor(false);
      document.getElementById("investors-tab").classList.add("active");
      document.getElementById("newinvestment-tab").classList.remove("active");
      document.getElementById("investors-tab-pane").classList.add("active");
      document.getElementById("newinvestment-tab-pane").classList.remove("active");
    }
    axios
      .post(base_url + "investor-master/get_investor_master")
      .then((res) => {
        
        let data = res.data.data;

        if (data !== "" || data !== undefined) {
          setLoading(false);
          let toal_amount = 0;
          let toal_amount_usd = 0;
          data.forEach((elemInvestmentAmount, index) => {
            elemInvestmentAmount.serial_number = index + 1;

            const committed = Number(elemInvestmentAmount.committed_principal) || 0;
            if (elemInvestmentAmount.currency_type == LOAN_CURRENCY_TYPE_USD) {
              toal_amount_usd = toal_amount_usd + committed;
            } else if (elemInvestmentAmount.currency_type == LOAN_CURRENCY_TYPE_BHD) {
              toal_amount = toal_amount + committed;
            }
          });

          setInvInterestData(data);
          setAllInvestorCount(data.length);
          setInvInterestFilter(data);
          setFourthValue(data);
          setFirstValue(data);
          setSecondValue(data);
          setThirdValue(data);
          setDisplayedData(data);
          setTotalInvestmentInDinar(toal_amount);
          setTotalInvestmentInDolor(toal_amount_usd);
        }
      })
      .catch((err) => {
        if (err.response.statusText == "Unauthorized") {
          toast.error("Your session has expired. Please login again", {
            toastId: 7,
          });
          Cookies.remove("User_Accesstoken_Admin");
          Cookies.remove("User_Refreshtoken_Admin");
          navigate("/adminlogin");
        }
      });
    axios
      .post(base_url + "investor-interests/get_investment_interests")
      .then((res) => {
        let data = res.data.data;
        if (data !== "" || data !== undefined) {
          let toal_amount = 0;
          let toal_amount_usd = 0;
          data.forEach((each_record, index) => {
            each_record.serial_number = index + 1;
            if (
              each_record.admin_request_loan_currency ==
                LOAN_CURRENCY_TYPE_BHD &&
              (each_record.status == STATUS_PROCESSED ||
                each_record.status == STATUS_CLOSED)
            ) {
              toal_amount = toal_amount + parseInt(each_record.loan_amount);
            }
            if (
              each_record.admin_request_loan_currency ==
                LOAN_CURRENCY_TYPE_USD &&
              (each_record.status == STATUS_PROCESSED ||
                each_record.status == STATUS_CLOSED)
            ) {
              toal_amount_usd =
                toal_amount_usd + parseInt(each_record.loan_amount);
            }
          });
          setLoading(false);
          setNewInvestInterest(data);
          setDisplayedData(data);
          setAllInvestorInvestCount(data.length);
          setTotalInvestmentInvestInDinar(toal_amount);
          setTotalInvestmentInvestInDolor(toal_amount_usd);
        }
      })
      .catch((err) => {
        if (err.response.statusText == "Unauthorized") {
          toast.error("Your session has expired. Please login again", {
            toastId: 7,
          });
          Cookies.remove("User_Accesstoken_Admin");
          Cookies.remove("User_Refreshtoken_Admin");
          navigate("/adminlogin");
        }
      });
  }, []);

  // Fund Now (multi-investor) loans are listed as their own rows in New Investment Interests
  // (FundNowLoanRows). Legacy single-investor actions are disabled for those loans' interest rows.
  const [multiInvestorLoanIds, setMultiInvestorLoanIds] = useState(() => new Set());
  // Disbursed Fund Now amounts, added to the "Total Investment" tiles alongside legacy loans.
  const [fundNowTotals, setFundNowTotals] = useState({ BHD: 0, USD: 0 });
  const [interestSearch, setInterestSearch] = useState("");
  // Decrypted synchronously so an auditor never sees Fund Now write actions, even on first render.
  const [isAuditorSession] = useState(() => {
    const stored = Cookies.get("role_code");
    if (!stored) return false;
    try {
      return Number(decrypt(stored)) === AUDITOR_ROLE;
    } catch (error) {
      return false;
    }
  });
  const handleFundNowLoaded = (opps) => {
    setMultiInvestorLoanIds(
      new Set(
        opps
          .filter((o) => Number(o.investor_count) > 0 || Number(o.disbursed_count) > 0)
          .map((o) => String(o.loan_id))
      )
    );
    const totals = { BHD: 0, USD: 0 };
    opps.forEach((o) => {
      if (o.status === STATUS_PROCESSED || o.loan_status === STATUS_CLOSED) {
        const c = o.currency === LOAN_CURRENCY_TYPE_USD ? "USD" : "BHD";
        totals[c] += Number(o.funded) || 0;
      }
    });
    setFundNowTotals(totals);
  };

  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const handleCloseRejectClose = () => {
    setShow(false);
  };
  const goToAdminDashboard = () => {
    navigate("/admindashboard");
  };
  const [flag, setFlag] = useState(false);

  function exportToExcel() {
    setFlag(true);
    let sample_data_array = [];
    invInterestFilter.forEach((elem) => {
      if (elem.currency_type === "USD") {
        elem.currency_type = "$";
      }
      let xl_object = {
        "Investor Name": elem.investor_name,
        "Ref No": elem.investor_reference_no,
        "Total Committed": elem.currency_type + " " + elem.committed_principal? elem.committed_principal:"0",
        "Total Disbursed": elem.currency_type + " " + elem.total_invested,
        "Total Profit": elem.profit,
        "Amount Transferred":elem.currency_type + " " +elem.amount_transferred
      };
      sample_data_array.push(xl_object);
    });
    // create the data that you want to write to the excel file
    const data = sample_data_array;

    // create a worksheet and add the data to it
    const worksheet = XLSX.utils.json_to_sheet(data);

    // create a workbook and add the worksheet to it
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // create the excel file and save it to the user's device
    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const fileName = "all_investors_list.xlsx";
    const file = new Blob(
      [XLSX.write(workbook, { bookType: "xlsx", type: "array" })],
      { type: fileType }
    );
    FileSaver.saveAs(file, fileName);
    setFlag(false);
  }
  const clearFilters = () => {
    setInvInterestFilter(invInterestData);
    setDefaultValue(true);
    setFourthValue(invInterestData);
    setFirstValue(invInterestData);
    setSecondValue(invInterestData);
    setThirdValue(invInterestData);
    setInitialValue('')
    setSecondFilterValue('')
    setThirdFilterValue('')
    setFourthFilterValue('')
  };

  const [initialValue, setInitialValue] = useState('')
  const [secondFilterValue, setSecondFilterValue] = useState('')
  const [thirdFilterValue, setThirdFilterValue] = useState('')
  const [fourthFilterValue, setFourthFilterValue] = useState('')

  const handleChangeInput = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    if (name === "inv_name" && secondFilterValue ==='' && thirdFilterValue==='' && fourthFilterValue==='') {
      setInitialValue("inv_name")
      let fname = firstValue.filter((item) => {
        if (value === item.investor_name) {
          return item;
        }
        if (value === "All") {
      setInitialValue("")

          return item;
        }
      });
      setInvInterestFilter(fname);
      setSecondValue(fname);
      setThirdValue(fname);
      setFourthValue(fname);
    }

    if (name === "refNo" && initialValue ==='' && thirdFilterValue==='' && fourthFilterValue==='') {
      setSecondFilterValue("refNo")
      let f = secondValue.filter((item) => {
        if (value === item.investor_reference_no) {
          return item;
        }
        if (value === "All") {
      setSecondFilterValue("")

          return item;
        }
      });
      setInvInterestFilter(f);
      setFirstValue(f);
      setThirdValue(f);
      setFourthValue(f);
    }
    if (name === "refNo" && initialValue !=='' ) {
      let f = secondValue.filter((item) => {
        if (value === item.investor_reference_no) {
          return item;
        }
        if (value === "All") {
      setSecondFilterValue("")

          return item;
        }
      });
      setInvInterestFilter(f);
      setThirdValue(f);
      setFourthValue(f);
    }
    if (name === "totalComtd" && initialValue==='' && secondFilterValue ==='' && fourthFilterValue==='') {
      setThirdFilterValue("totalComtd")
      let startRange = value.split("-")[0];
      let endRange = value.split("-")[1];

      let f = thirdValue.filter((item) => {
        if (item.currency_type === LOAN_CURRENCY_TYPE_BHD) {
          let committedAmount = Number(item.committed_principal);
          let initialAmount = Number(startRange);
          let finalAmount = Number(endRange);

          if (
            committedAmount >= initialAmount &&
            item.committed_principal <= finalAmount
          ) {
            return item;
          }
        }
        if (item.currency_type === LOAN_CURRENCY_TYPE_USD) {
          let committedAmount = Number(item.committed_principal);
          let initialAmount = Number(startRange);
          let finalAmount = Number(endRange);

          if (
            committedAmount >= initialAmount &&
            item.committed_principal <= finalAmount
          ) {
            return item;
          }
        }
        if (value === "All") {
      setThirdFilterValue("")

          return item;
        }
      });
      setInvInterestFilter(f);
      setFirstValue(f);
      setSecondValue(f);
      setFourthValue(f);
    }

    if (name === "totalComtd" && initialValue==='' ) {
      let startRange = value.split("-")[0];
      let endRange = value.split("-")[1];

      let f = thirdValue.filter((item) => {
        if (item.currency_type === LOAN_CURRENCY_TYPE_BHD) {
          let committedAmount = Number(item.committed_principal);
          let initialAmount = Number(startRange);
          let finalAmount = Number(endRange);

          if (
            committedAmount >= initialAmount &&
            item.committed_principal <= finalAmount
          ) {
            return item;
          }
        }
        if (item.currency_type === LOAN_CURRENCY_TYPE_USD) {
          let committedAmount = Number(item.committed_principal);
          let initialAmount = Number(startRange);
          let finalAmount = Number(endRange);

          if (
            committedAmount >= initialAmount &&
            item.committed_principal <= finalAmount
          ) {
            return item;
          }
        }
        if (value === "All") {
      setThirdFilterValue("")

          return item;
        }
      });
      setInvInterestFilter(f);
      setSecondValue(f);
      setFourthValue(f);
    }
    if (name === "rate" && initialValue==='' && secondFilterValue ==='' && thirdFilterValue ==='') {
      setFourthFilterValue("rate")
      let NumberValue = Number(value);
      let f = fourthValue.filter((item) => {
        if (NumberValue === item.profit) {
          return item;
        }
        if (value === "All") {
      setFourthFilterValue("")

          return item;
        }
      });
      setInvInterestFilter(f);
      setFirstValue(f);
      setSecondValue(f);
      setThirdValue(f);
    }
    if (name === "rate" && initialValue!=='' ) {
      setFourthFilterValue("rate")
      let NumberValue = Number(value);
      let f = fourthValue.filter((item) => {
        if (NumberValue === item.profit) {
          return item;
        }
        if (value === "All") {
      setFourthFilterValue("")

          return item;
        }
      });
      setInvInterestFilter(f);
      setSecondValue(f);
      setThirdValue(f);
    }

    setDefaultValue(false);
  };

  const uniqueInvestorName = [
    ...new Set(firstValue.map((d) => d.investor_name)),
  ];
  const uniquelrefNo = [
    ...new Set(secondValue.map((d) => d.investor_reference_no)),
  ];
  const uniquelCommittedPrincipal = [
    ...new Set(thirdValue.map((d) => d.committed_principal)),
  ];
  const uniqueRate = [...new Set(fourthValue.map((d) => d.profit))];

  const [defaultvalueInvestor, setDefaultValueForInvestor] = useState(false);
  const investorClick = () => {
    Cookies.set("is_first_tab", true, { expires: 7 });
    setDefaultValueForInvestor(false);
  };
  const newInvestorIntrestsClick = () => {
    Cookies.set("is_first_tab", false, { expires: 7 });
    setDefaultValueForInvestor(true);
  };
  const columns = [
    {
      title: "Sr.No",
      field: "serial_number",
    },
    {
      title: "Investor Company Name",
      field: "investor_company_name",

      sort: (a, b) => a.investor_name.localeCompare(b.investor_company_name),
    },
    {
      title: "Investor Name",
      field: "investor_name",
      sort: (a, b) => a.investor_name.localeCompare(b.investor_name),
    },
    {
      title: "Ref No",
      field: "investor_reference_no",
      sort: (a, b) =>
        a.investor_reference_no.localeCompare(b.investor_reference_no),
    },
    {
      title: "Total Committed",
      field: "committed_principal",
      currency: "currency_type",
    },
    {
      title: "Total Disbursed",
      field: "total_invested",
      currency: "currency_type",
    },
    {
      title: "Total Profit",
      field: "profit",
      currency: "currency_type",
    },
    {
      title: "Amount Transferred",
      field: "amount_transferred",
      currency: "currency_type",
    },
    {
      title: "Actions",
      field: "image",
      image: "./images/icons/double_arrow.svg",
      datatopass: "",
    },
  ];
  const columnstwo = [
    { title: "Investor Name", field: "investor_name" },
    { title: "Business Name", field: "business_name" },
    { title: "Loan Ref No", field: "loan_reference_no" },
    {
      title: "Investment",
      field: "loan_amount",
      currency: "admin_request_loan_currency",
    },
    { title: "Ben ROI", field: "bennefin_roi" },
    { title: "Inv ROI", field: "investor_roi" },
    { title: "Profit", field: "profit" },
    { title: "Status", field: "status" },
    { title: "Tenure", field: "admin_request_loan_tenure" },
    {
      title: "Actions",
      field: "",
      image: "./images/paperrocket.svg",
      datatopass: "",
    },
  ];

  const handleSort = (column) => {
    let direction = "asc";
    if (sortOrder.column === column && sortOrder.direction === "asc") {
      direction = "desc";
    }
    setSortOrder({ column, direction });

    const sortedData = [...invInterestFilter].sort((a, b) => {
      const columnA = a[column];
      const columnB = b[column];
      if (typeof columnA === "string" && typeof columnB === "string") {
        return direction === "asc"
          ? columnA.localeCompare(columnB)
          : columnB.localeCompare(columnA);
      } else if (typeof columnA === "number" && typeof columnB === "number") {
        return direction === "asc" ? columnA - columnB : columnB - columnA;
      } else {
        return 0;
      }
    });
    setInvInterestFilter(sortedData);
  };

  const handleSorttwo = (column) => {
    let direction = "asc";
    if (sortOrder.column === column && sortOrder.direction === "asc") {
      direction = "desc";
    }
    setSortOrder({ column, direction });

    const sortedData = [...newInvestInterest].sort((a, b) => {
      const columnA = column == "loan_amount" ? parseInt(a[column]) : a[column];
      const columnB = column == "loan_amount" ? parseInt(b[column]) : b[column];
      if (typeof columnA === "string" && typeof columnB === "string") {
        return direction === "asc"
          ? columnA.localeCompare(columnB)
          : columnB.localeCompare(columnA);
      } else if (typeof columnA === "number" && typeof columnB === "number") {
        return direction === "asc" ? columnA - columnB : columnB - columnA;
      } else {
        return 0;
      }
    });
    setNewInvestInterest(sortedData);
  };

  const [modalShow, setModalShow] = React.useState(false);
  const [modalLoanDisbShow, setModalLoanDisbShow] = React.useState(false);
  const [viewDetailsModal, setViewDetailsModal] = React.useState(false);
  let prevLocation = window.location.pathname
  const handleHideContent = (props) => {
    navigate("/singleinvestordetails", { state: { props, prevLocation } });
  };

  const [indivAction, setIndivAction] = useState([]);
  const [indivActionAccepted, setIndivActionAccepted] = useState([]);
  const [datatoDetailsModal, setDatatoDetailsModal] = useState([]);

  const handleIndivDetails = (interst) => {
    setIndivAction(interst);
  };
  const handleIndivDetailsAccepted = (interst) => {
    setIndivActionAccepted(interst);
  };
  const handleViewDetails = (i) => {
    setViewDetailsModal(true);
    setDatatoDetailsModal(i);
  };

  const getColumnSize = (investment) => {
    if (investment > 1000000) {
      return 'col-md-6';
    } else if (investment > 500000) {
      return 'col-md-4';
    } else {
      return 'col-md-2';
    }
  };
  const [roleCode, setRoleeCode] = useState(() => {
    const storedRoleeCode = Cookies.get('role_code');
    return storedRoleeCode ? storedRoleeCode : '';
  });

  useEffect(()=>{
    if (roleCode) {
      try {
        const decryptedValueData = decrypt(roleCode);
        setRoleeCode(decryptedValueData);
      } catch (error) {
        console.error('Decryption error:', error);
      }
    }
  },[])

  return (
    <div>
      <AdminNavBarMain />

      <div className="row admin_body_main bg-transparent">
        <div className="d-flex justify-content-between">
          <div className="col d-flex justify-content-between my-xxl-2  my-lg-1">
            <h5
              className="admin_serv mb-1"
              onClick={() => goToAdminDashboard(true)}
            >
              <img
                src="./images/left_arrow.svg"
                alt=""
                className="indiv_loan_dtls"
              />
              &nbsp; All Investors
            </h5>
          </div>
        </div>
        {defaultvalueInvestor == false ? (
          <div className="container p-0">
            <div className="row d-flex justify-content-between mb-2">
              <div className="col-md-2 mb-3 mb-md-0  ">
                <div className=" b_style_new ms-0">
                  <span> No. of Investors</span>
                  <p className="p_style">{allInvestorsCount}</p>
                </div>
              </div>

              <div className={`${getColumnSize(Number(totalInvestmentDolor || 0) + Number(totalInvestment || 0))} mb-3 mb-md-0`}>
                <div className=" n_style_new">
                  <span>Total Committed</span>
                  <p className="p_style">
                    {totalInvestment === undefined
                      ? ""
                      : "BHD\u00A0" + Number(totalInvestment).toLocaleString() +
                        " + $\u00A0" + Number(totalInvestmentDolor).toLocaleString()}
                  </p>
                </div>
              </div>
              <div className="col-md-2 mb-3 mb-md-0">
              <input
              id="all"
              name="all"
              type="text"
              className="form-control rounded px-4 py-3 border-0 w-100"
              placeholder="Search by keywords"
              onChange={(e)=>handleChangeAllInput(e)}
              />
            </div>
              <div className="col text-end">
                <div className=" count_of_records_ALLSR">
                  <span>No.of Records : {count}</span>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="container p-0">
            <div className="row d-flex justify-content-between mb-2">
              <div className="col-md-2 mb-3 mb-md-0  ">
                <div className=" b_style_new ms-0 ">
                  <span> No. of Interests received</span>
                  <p className="p_style">{allInvestorsInvestCount}</p>
                </div>
              </div>
              <div className="col-md-2 mb-3 mb-md-0">
                <div className=" n_style_new">
                  <span>Total Investment in Dinar</span>
                  <p className="p_style">
                    {"BHD " +
                      (totalInvestmentInvest == undefined
                        ? ""
                        : (Number(totalInvestmentInvest) + fundNowTotals.BHD).toLocaleString(
                            "en-IN"
                          ))}
                  </p>
                </div>
              </div>
              <div className="col-md-2 mb-3 mb-md-0">
                <div className=" g_style_new">
                  <span>Total Investment in Dollar</span>
                  <p className="p_style">
                    {"$\u00A0" +
                      (totalInvestmentDolorInvest == undefined
                        ? ""
                        : (Number(totalInvestmentDolorInvest) + fundNowTotals.USD).toLocaleString(
                            "en-IN"
                          ))}
                  </p>
                </div>
              </div>
              <div className="col-md-2 mb-3 mb-md-0 new-investment-styling-sb">
              <input
              id="all"
              name="all"
              type="text"
              className="form-control rounded px-4 py-3 border-0 w-100"
              placeholder="Search by keywords"
              onChange={(e)=>handleChangeAllInputInterests(e)}
              />
            </div>
              <div className="col text-end"></div>
            </div>
          </div>
        )}
      </div>

      <div className="">
        <div className="AllInv_top_tab pe-5 ps-5">
          <ul className="nav nav-tabs d-flex" id="myTab" role="tablist">
            <li className="nav-item-inv" role="presentation">
              <button
                onClick={investorClick}
                className="nav-link-inv  p-1"
                id="investors-tab"
                data-bs-toggle="tab"
                data-bs-target="#investors-tab-pane"
                type="button"
                role="tab"
                aria-controls="investors-tab-pane"
                aria-selected="true"
              >
                <h3>Investors</h3>
              </button>
            </li>
            <li className="nav-item-inv" role="presentation">
              <button
                onClick={newInvestorIntrestsClick}
                className="nav-link-inv p-1 x"
                id="newinvestment-tab"
                data-bs-toggle="tab"
                data-bs-target="#newinvestment-tab-pane"
                type="button"
                role="tab"
                aria-controls="newinvestment-tab-pane"
                aria-selected="false"
              >
                <h3>New Investment Interests</h3>
              </button>
            </li>
          </ul>
        </div>
        <div
          className="tab-content idiv_inv_left_card_text pe-5 ps-5"
          id="myTabContent"
        >
          <div
            className="tab-pane fade show "
            id="investors-tab-pane"
            role="tabpanel"
            aria-labelledby="investors-tab"
            tabIndex="0"
          >
            <div>
              {defaultvalueInvestor == false ? (
                <div className="row mb-3 mt-2 gap-3">
                  <div className="col">
                    <label htmlFor="inv_name" className="form-label">
                      <p>Search by Investor</p>
                    </label>
                    <select
                      id="inv_name"
                      className="form-select dropdn_select_cls  shadow-ben APNL_option_flds"
                      aria-label="form-select example"
                      name="inv_name"
                      autoComplete="off"
                      onChange={handleChangeInput}
                    >
                      <option selected={defaultvalue}>All</option>

                      {uniqueInvestorName.map((type) => {
                        return <option key={type}>{type}</option>;
                      })}
                    </select>
                  </div>

                  <div className="col-lg">
                    <label htmlFor="refNo" className="form-label">
                      <p>Ref No.</p>
                    </label>
                    <select
                      id="refNo"
                      className="form-select dropdn_select_cls  shadow-ben APNL_option_flds"
                      aria-label="form-select example"
                      name="refNo"
                      autoComplete="off"
                      onChange={handleChangeInput}
                    >
                      <option selected={defaultvalue}>All</option>
                      {uniquelrefNo.map((refno) => {
                        return <option key={refno}>{refno}</option>;
                      })}
                    </select>
                  </div>

                  <div className="col-lg">
                    <label htmlFor="totalComtd" className="form-label">
                      <p>Total Committed</p>
                    </label>
                    <select
                      className="form-select  dropdn_select_cls shadow-ben APNL_option_flds"
                      id="totalComtd"
                      onChange={handleChangeInput}
                      name="totalComtd"
                    >
                      <option selected={defaultvalue}>All</option>
                      <option value="1000-5000">1000 - 5000</option>
                      <option value="5001-10000">5001 - 10000</option>
                      <option value="10001-50000">10001 - 50000</option>
                      <option value="50001-100000">50001 - 100000</option>
                      <option value="100001-150000">100001 - 150000</option>
                      <option value="150001-200000">150001 - 200000</option>
                      <option value="200001-250000">200001 - 250000</option>
                      <option value="250001-300000">250001 - 300000</option>
                      <option value="300001-350000">300001 - 350000</option>
                      <option value="350001-400000">350001 - 400000</option>
                      <option value="400001-450000">400001 - 450000</option>
                      <option value="450001-500000">450001 - 500000</option>
                      <option value="500001-750000">500001 - 750000</option>
                      <option value="750001-1000000">750001 - 1000000</option>
                    </select>
                  </div>

                  <div className="col-lg-1">
                    <label htmlFor="rate" className="form-label">
                      <p>Return Rate</p>
                    </label>
                    <select
                      id="rate"
                      className="form-select dropdn_select_cls  shadow-ben APNL_option_flds"
                      aria-label="form-select example"
                      name="rate"
                      autoComplete="off"
                      onChange={handleChangeInput}
                    >
                      <option selected={defaultvalue}>All</option>
                      {uniqueRate.map((type) => {
                        return <option key={type}>{type}</option>;
                      })}
                    </select>
                  </div>
                  <div className=" col align-self-end">
                    <button className="blue_btn" onClick={clearFilters}>
                      Clear All Filters
                    </button>
                  </div>

                  <div className="col btn_style">
                    <button className="blue_btn " onClick={exportToExcel} disabled={roleCode===AUDITOR_ROLE}>
                      Download XLS
                    </button>
                  </div>
                </div>
              ) : (
                <div className="row mb-2 mt-5 gap-3"></div>
              )}
            </div>
            <div className="allinv_inv_table">
              <Table
                striped
                // bordered
                className="bg-white ps-4 pe-4 text-center investor_table_headers"
              >
                <TableData
                  ltwo={ltwo}
                  loading={loading}
                  data={invInterestFilter}
                  columns={columns}
                  handleSort={handleSort}
                  onImageClick={handleHideContent}
                />
              </Table>
            </div>
          </div>

          <div
            className="tab-pane fade show"
            id="newinvestment-tab-pane"
            role="tabpanel"
            aria-labelledby="newinvestment-tab"
            tabIndex="0"
          >
            <div className="adminall_inv_newinv_table">
              <Table striped className="bg-white ps-4 pe-4 text-center ">
                <thead className="all_inv_table_head">
                  <tr>
                    {columnstwo.map((column) => {
                      return (
                        <>
                          <th
                            key={column.field}
                            onClick={() => handleSorttwo(column.field)}
                          >
                            {ltwo || loading ? (
                              <Skeleton width={100} height={15} />
                            ) : column.title !== "Actions" ? (
                              <div className="text-black table_data_header_styl">
                                {" "}
                                {column.title}&#9662;
                              </div>
                            ) : (
                              column.title
                            )}
                          </th>
                        </>
                      );
                    })}
                  </tr>
                </thead>
                <tbody>
                  <FundNowLoanRows
                    ltwo={ltwo}
                    search={interestSearch}
                    canWrite={!!Cookies.get("User_Accesstoken_Admin") && !isAuditorSession}
                    onLoaded={handleFundNowLoaded}
                  />
                  {newInvestInterest.map((interst, index) => {
                    return (
                      <tr key={index} className="new_inv_interst_table">
                        <td>
                          {interst.investor_name == undefined ? (
                            "-"
                          ) : (
                            <div className="">
                              {ltwo || loading ? (
                                <Skeleton width={100} height={15} />
                              ) : (
                                interst.investor_name
                              )}
                            </div>
                          )}
                        </td>
                        <td>
                          {interst.business_name == undefined ? (
                            "-"
                          ) : ltwo || loading ? (
                            <Skeleton width={100} height={15} />
                          ) : (
                            interst.business_name
                          )}
                        </td>
                        <td>
                          {interst.loan_reference_no == undefined ? (
                            "-"
                          ) : ltwo || loading ? (
                            <Skeleton width={100} height={15} />
                          ) : (
                            interst.loan_reference_no
                          )}
                        </td>
                        <td>
                          {interst.loan_amount == undefined ? (
                            "-"
                          ) : ltwo || loading ? (
                            <Skeleton width={100} height={15} />
                          ) : (
                            (interst.admin_request_loan_currency ===
                            LOAN_CURRENCY_TYPE_BHD
                              ? "BHD "
                              : LOAN_CURRENCY_TYPE_USD
                              ? "$\u00A0"
                              : "") +
                            Number(interst.loan_amount).toLocaleString()
                          )}
                        </td>
                        <td>
                          {interst.bennefin_roi == undefined ? (
                            "-"
                          ) : ltwo || loading ? (
                            <Skeleton width={100} height={15} />
                          ) : (
                            interst.bennefin_roi + "%"
                          )}
                        </td>
                        <td>
                          {interst.investor_roi == undefined ? (
                            "-"
                          ) : ltwo || loading ? (
                            <Skeleton width={100} height={15} />
                          ) : (
                            interst.investor_roi + "%"
                          )}
                        </td>
                        <td>
                          {interst.profit == undefined ? (
                            "-"
                          ) : ltwo || loading ? (
                            <Skeleton width={100} height={15} />
                          ) : (
                            (interst.admin_request_loan_currency ==
                            LOAN_CURRENCY_TYPE_BHD
                              ? LOAN_CURRENCY_TYPE_BHD + " "
                              : "$\u00A0") + Number(interst.profit).toLocaleString()
                          )}
                        </td>
                        <td>
                          {interst.status == undefined ? (
                            "-"
                          ) : (
                            <div
                              style={{
                                color: `${
                                  interst.status === STATUS_APPROVED
                                    ? "Green"
                                    : interst.status === STATUS_REJECTED
                                    ? "Red"
                                    : interst.status === STATUS_PROCESSED
                                    ? "#3D79F3"
                                    : interst.status === STATUS_CLOSED
                                    ? "#bcbec0"
                                    : interst.status === STATUS_IN_PROGRESS &&
                                      interst.is_admin_sent_terms_to_business ==
                                        0
                                    ? "Orange"
                                    : "Black"
                                }`,
                                fontWeight: "400",
                              }}
                            >
                              {ltwo || loading ? (
                                <Skeleton width={100} height={15} />
                              ) : interst.status === STATUS_IN_PROGRESS &&
                                interst.is_admin_sent_terms_to_business ===
                                  0 ? (
                                <span className="newinvintstatus">
                                  {" "}
                                  <img src="./images/singledot.svg" alt="" />
                                  <br />
                                  In Progress
                                </span>
                              ) : interst.status === STATUS_IN_PROGRESS &&
                                interst.is_admin_sent_terms_to_business ===
                                  1 ? (
                                <span className="newinvintstatus">
                                  {" "}
                                  <img src="./images/doubledots.svg" alt="" />
                                  <br />
                                  Pending Acceptance
                                </span>
                              ) : interst.status === STATUS_APPROVED ? (
                                <span className="newinvintstatus">
                                  {" "}
                                  <img src="./images/tripledots.svg" alt="" />
                                  <br /> Offer Accepted
                                </span>
                              ) : interst.status === STATUS_PROCESSED ? (
                                <span className="newinvintstatus">
                                  {" "}
                                  <img src="./images/fourdots.svg" alt="" />
                                  <br />
                                  Payment Processed
                                </span>
                              ) : interst.status === STATUS_CLOSED ? (
                                <span className="newinvintstatus"> Closed</span>
                              ) : interst.status === LOAN_DELISTED ? (
                                <span className="newinvintstatus"> Delisted</span>
                              ) : interst.status === LOAN_TECHNICAL_CLOSURE ? (
                                <span className="newinvintstatus">
                                {" "}
                                <img src="./images/singledot.svg" alt="" />
                                <br />
                                Technical Closure
                              </span>
                              )
                              
                              
                              : (
                                ""
                              )}
                            </div>
                          )}
                        </td>
                        <td>
                          {interst.admin_request_loan_tenure == undefined ? (
                            "-"
                          ) : ltwo || loading ? (
                            <Skeleton width={100} height={15} />
                          ) : (
                            interst.admin_request_loan_tenure +
                            (interst.admin_request_loan_tenure == 1
                              ? " Month"
                              : " Months")
                          )}
                        </td>
                        <td>
                          {ltwo || loading ? (
                            <Skeleton width={100} height={15} />
                          ) : (
                            <div className="allinve_action_td">
                              {interst.status === STATUS_IN_PROGRESS &&
                              interst.is_admin_sent_terms_to_business === 0 ? (
                                interst.is_processed === 0 ? (
                                  multiInvestorLoanIds.has(String(interst.loan_id)) ? (
                                  <span
                                    className="pe-3"
                                    title="This loan is funded through Fund Now - use its Fund Now row in this table"
                                    style={{ fontSize: 12, fontWeight: 600, color: "#7C8495", whiteSpace: "nowrap" }}
                                  >
                                    Fund Now loan
                                  </span>
                                  ) : (
                                  <img
                                    className="pe-3 Cpointer "
                                    src="./images/bluerocket.svg"
                                    alt=""
                                    onClick={() =>
                                      setModalShow(
                                        true,
                                        handleIndivDetails(interst)
                                      )
                                    }
                                  />
                                  )
                                ) : (
                                  <img
                                    className="pe-3  "
                                    src="./images/bluerocket_cross.svg"
                                    alt=""
                                  />
                                )
                              ) : interst.status === STATUS_PROCESSED ? (
                                <img
                                  className="pe-3 Cpointer"
                                  src="./images/pencil.svg"
                                  alt=""
                                  onClick={() =>
                                    setModalLoanDetailsShow(
                                      true,
                                      handleIndivDetails(interst)
                                    )
                                  }
                                />
                              ) : interst.status === STATUS_IN_PROGRESS &&
                                interst.is_admin_sent_terms_to_business ===
                                  1 ? (
                                <img
                                  className="pe-3 "
                                  src="./images/senddisabled.svg"
                                  alt=""
                                />
                              ) : interst.status === STATUS_CLOSED &&
                                interst.is_admin_sent_terms_to_business ===
                                  1 ? (
                                <img
                                  className="pe-3 closed_eye_styl"
                                  src="./images/close_icon.svg"
                                  alt=""
                                />
                              ) : multiInvestorLoanIds.has(String(interst.loan_id)) ? (
                                <span
                                  className="pe-3"
                                  title="This loan is funded through Fund Now - use its Fund Now row in this table"
                                  style={{ fontSize: 12, fontWeight: 600, color: "#7C8495", whiteSpace: "nowrap" }}
                                >
                                  Fund Now loan
                                </span>
                              ) : (
                                <img
                                  className="pe-3 Cpointer"
                                  src="./images/check.svg"
                                  alt=""
                                  onClick={() =>
                                    setModalLoanDisbShow(
                                      true,
                                      handleIndivDetailsAccepted(interst)
                                    )
                                  }
                                />
                              )}
                              <img
                                className="indiv_loan_dtls_eye"
                                src="./images/icons/blue_eye.svg"
                                alt=""
                                onClick={() => handleViewDetails(interst)}
                              />
                            </div>
                          )}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </div>

            <Modal show={show} onHide={handleCloseRejectClose}>
              <Modal.Header closeButton>
                <Modal.Title>Alert</Modal.Title>
              </Modal.Header>
              <Modal.Body className="alert_modal">
                Are you sure you want to delete?
              </Modal.Body>
              <div className="p-2 d-flex justify-content-end gap-3">
                <button
                  className="btn px-3"
                  style={{ backgroundColor: "grey", color: "white" }}
                  variant="primary"
                  onClick={handleCloseRejectClose}
                >
                  Cancel
                </button>
                <button
                  className="btn px-4"
                  style={{ backgroundColor: "#ED5151", color: "white" }}
                  variant="danger"
                  // onClick={handleCloseReject}
                >
                  Yes
                </button>
              </div>
            </Modal>

            {indivAction.length !== 0 ? (
              <NewInvestInterestActions
                indivaction={indivAction}
                ltwo={ltwo}
                show={modalShow}
                onHide={() => setModalShow(false)}
              />
            ) : (
              ""
            )}
            {indivActionAccepted.length !== 0 ? (
              <LoanDisbursement
                show={modalLoanDisbShow}
                data={{
                  ...indivActionAccepted,
                  is_multi_investor: multiInvestorLoanIds.has(String(indivActionAccepted.loan_id)),
                }}
                onHide={() => setModalLoanDisbShow(false)}
              />
            ) : (
              ""
            )}
            <NewInvDetailedView
              data={indivAction}
              show={modalLoanDetailsShow}
              onHide={() => setModalLoanDetailsShow(false)}
            />
            <ViewPerticularInvDetails
              data={datatoDetailsModal}
              show={viewDetailsModal}
              onHide={() => setViewDetailsModal(false)}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminInvestors;

export const ViewPerticularInvDetails = (props) => {
  let { data } = props;

  const handleClose = () => {
    props.onHide();
  };
  return (
    <Modal
      {...props}
      dialogClassName="modal-190w"
      aria-labelledby="example-custom-modal-styling-title"
      size="lg"
      backdrop="static"
      keyboard={false}
      centered
    >
      <Modal.Header
        onHide={handleClose}
        closeButton
        className="modal_title"
        style={{ height: "55px" }}
      >
        <Modal.Title id="example-custom-modal-styling-title">
          <div className=" ps-2 d-flex justify-content-between">
            <div className="heading_new_loan ">
              <h5 className="mb-0 me-5 pe-5">View Details</h5>
            </div>
          </div>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className="px-4 py-2" style={{ height: "28rem" }}>
        <div className="container p-0 pb-3">
          <div className="row">
            <div className="container ps-0 d-flex mb-3">
              <div className="col-lg-4  mb-3 me-1">
                <p className="text_ststrong ">Business Name</p>
                <span className="bolder_textstrong ">
                  {data.business_name === undefined ? "-" : data.business_name}
                </span>
              </div>
              <div className="col mb-4">
                <p className="text_ststrong ">Investor Name</p>
                <span className="bolder_textstrong ">
                  {data.investor_name === undefined ? "-" : data.investor_name}
                </span>
              </div>
            </div>
            <div className="col ">
              
              <div className="mb-4">
                <p className="text_st ">Loan type</p>
                <span className="bolder_text ">
                  {data.loan_type_name === undefined
                    ? "-"
                    : data.loan_type_name}
                </span>
              </div>
              <div className="mb-4">
                <p className="text_st ">Loan Reference No.</p>
                <span className="bolder_text ">
                  {data.loan_reference_no === undefined
                    ? "-"
                    : data.loan_reference_no}
                </span>
              </div>
              <div className="mb-4">
                <p className="text_st ">Interest Frequency</p>
                <span className="bolder_text ">
                  {data.interest_frequency === undefined ||
                  data.interest_frequency === ""
                    ? "-"
                    : data.interest_frequency}
                </span>
              </div>
              <div className="mb-4">
                <p className="text_st ">Processing Fee</p>
                <span className="bolder_text ">
                  {data.processing_fees === undefined ||
                  data.processing_fees === ""
                    ? "-"
                    : data.admin_request_loan_currency ===
                      LOAN_CURRENCY_TYPE_BHD
                    ? "BHD " + data.processing_fees
                    : data.admin_request_loan_currency ===
                      LOAN_CURRENCY_TYPE_USD
                    ? "$\u00A0" + data.processing_fees
                    : "-"}
                </span>
              </div>
            </div>

            <div className="col">
              <div className="mb-4">
                <p className="text_st ">Requested Tenure Period</p>
                <span className="bolder_text ">
                  {data.admin_request_loan_tenure === undefined ||
                  data.admin_request_loan_tenure === ""
                    ? "-"
                    : data.admin_request_loan_tenure === 1
                    ? data.admin_request_loan_tenure + " Month"
                    : data.admin_request_loan_tenure > 1
                    ? data.admin_request_loan_tenure + " Months"
                    : "-"}
                </span>
              </div>
              <div className="mb-4">
                <p className="text_st ">Amount Borrowed</p>
                <span className="bolder_text ">
                  {data.loan_amount === undefined || data.loan_amount === ""
                    ? "-"
                    : data.admin_request_loan_currency ===
                      LOAN_CURRENCY_TYPE_BHD
                    ? "BHD " + Number(data.loan_amount).toLocaleString()
                    : data.admin_request_loan_currency ===
                      LOAN_CURRENCY_TYPE_USD
                    ? "$\u00A0" + Number(data.loan_amount).toLocaleString()
                    : "-"}
                </span>
              </div>
              <div className="mb-4">
                <p className="text_st ">Investor ROI</p>
                <span className="bolder_text ">
                  {data.investor_roi === undefined || data.investor_roi === ""
                    ? "-"
                    : data.investor_roi + "%"}
                </span>
              </div>
              <div className="mb-4">
                <p className="text_st ">Loan Purpose</p>
                <div className="loan_purps_notes">
                  <span className="bolder_text ">
                    {data.loan_purpose === undefined || data.loan_purpose === ""
                      ? "-"
                      : data.loan_purpose}
                  </span>
                </div>
              </div>
            </div>
            <div className="col">
              <div className="mb-4">
                <p className="text_st ">Status</p>
                <span className="bolder_text ">
                  {data.status === STATUS_NEW
                    ? "New"
                    : data.status === STATUS_IN_PROGRESS
                    ? "In progress"
                    : data.status === STATUS_APPROVED
                    ? "Approved"
                    : data.status === STATUS_REJECTED
                    ? "Rejected"
                    : data.status === STATUS_PROCESSED
                    ? "Processed"
                    : data.status === STATUS_CLOSED
                    ? "Closed"
                    : "-"}
                </span>
              </div>
              <div className="mb-4">
                <p className="text_st ">Loan Purpose</p>
                <span className="bolder_text ">
                  {data.loan_purpose === undefined || data.loan_purpose === ""
                    ? "-"
                    : data.loan_purpose}
                </span>
              </div>
              <div className="mb-4">
                <p className="text_st ">Processing Fee Type</p>
                <span className="bolder_text ">
                  {data.processing_fees_type === undefined ||
                  data.processing_fees_type === ""
                    ? "-"
                    : data.processing_fees_type}
                </span>
              </div>
            </div>
           
          
          </div>





        </div>
      </Modal.Body>
      <Modal.Footer className="d-flex  ps-3 pe-3">
        <div>
          <button
            className="btn btn_background mx-2 px-3 py-2"
            onClick={handleClose}
          >
            Close
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};
export const NewInvestInterestActions = (props) => {
  let loading = props.loading;
  let ltwo = props.ltwo;
  const [schedules, setSchedulesData] = useState([]);
  let invInterestID = props.indivaction.investor_interest_id;
  let loanID = props.indivaction.loan_id;
  let businessID = props.indivaction.business_id;
  let investorID = props.indivaction.investor_id;
  let investoRequestId = props.indivaction.investor_request_id;
  let schedulesData = props.indivaction.payment_schedule;
  const [sortOrder, setSortOrder] = useState({ column: null, direction: null });
  const [activeTabBool, setActiveTabBool] = useState(false);
  const navigate = useNavigate();
  const [roleCode,setRoleCode]=useState(Cookies.get("role_code"));

  useEffect(() => {
    schedulesData?.map((element) => {
      element.is_selected = false;
      element.color = "black";
    });
    setSchedulesData(schedulesData);
  }, [schedulesData]);

  
  useEffect(()=>{
    if(roleCode){
      const decryptedValueData = decrypt(roleCode);
      setRoleCode(decryptedValueData);
    }
  },[])

  const submitted = () => {
    setActiveTabBool(true);
    axios
      .post(base_url + "investor-interests/update_is_investor_interested", {
        admin_user_id: Cookies.get("admin_user_id"),
        admin_user_name: Cookies.get("admin_user_name"),
        investor_interest_id: invInterestID,
        investor_id: investorID,
        loan_id: loanID,
        business_id: businessID,
        investor_request_id: investoRequestId,
      })
      .then((res) => {
        axios
          .post(
            base_url + "payment-schedules/update_payment_schedule",
            schedules
          )
          .then((res) => {
            if (res.data.status === 200) {
              toast.success("Success", {
                toastId: 4,
              });
              props.onHide();
              setTimeout(() => {
                window.location.reload();
              }, 800);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const handleClose = () => {
    props.onHide();
    schedules?.map((element) => {
      element.is_selected = false;
      element.color = "black";
    });
    setSchedulesData(schedulesData);
  };
  const onPenClick = (id) => {
    let sch = [...schedules];
    sch = sch.map((ele) => {
      if (ele.payment_schedule_id === id) {
        ele.is_selected = true;
        ele.color = "yellow";
      } else {
        ele.is_selected = false;
        ele.color = "black";
      }
      return ele;
    });
    setSchedulesData(sch);
  };
  const handleDateChange = (e, id, index) => {
    let sch = [...schedules];
    let current_date = parseInt(
      Math.round(new Date(e).getTime() / 1000) + "000"
    );
    sch[index]["tenure_date"] = current_date;
    sch[index]["is_selected"] = false;
    sch[index]["color"] = "black";
    setSchedulesData(sch);
  };
  const handleSort = (column) => {
    let direction = "asc";
    if (sortOrder.column === column && sortOrder.direction === "asc") {
      direction = "desc";
    }
    setSortOrder({ column, direction });

    const sortedData = [...schedules].sort((a, b) => {
      const columnA = a[column];
      const columnB = b[column];
      if (typeof columnA === "string" && typeof columnB === "string") {
        return direction === "asc"
          ? columnA.localeCompare(columnB)
          : columnB.localeCompare(columnA);
      } else if (typeof columnA === "number" && typeof columnB === "number") {
        return direction === "asc" ? columnA - columnB : columnB - columnA;
      } else {
        return 0;
      }
    });
    setSchedulesData(sortedData);
  };
  const headers = [
    {
      title: "Profit Amount Payment",
      sort: "tenure_amount",
      currency: "admin_request_loan_currency",
    },
    { title: "Tenure Date", sort: "tenure_date" },
    { title: "Edit" },
  ];
  return (
    <Modal
      {...props}
      dialogClassName="modal-190w"
      aria-labelledby="example-custom-modal-styling-title"
      size="lg"
      backdrop="static"
      keyboard={false}
      centered
    >
      <Modal.Header
        onHide={handleClose}
        closeButton
        className="modal_title"
        style={{ height: "55px" }}
      >
        <Modal.Title id="example-custom-modal-styling-title">
          <div className=" ps-2 d-flex justify-content-between">
            <div className="heading_new_loan ">
              <h5 className="mb-0 me-5 pe-5">View Investment</h5>
            </div>
            <div className="head_onedot">
              <img src="./images/inprogressStepper.svg" alt="" />
              <h5 className="green-title ">In progress</h5>
            </div>
          </div>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className="px-4 py-2" style={{ height: "28rem" }}>
        <div className="row">
          <div className="col-lg-12">
            <div className="row mb-3">
              <div className="col ">
                <p className="text_st">Business Name</p>
                <div className="bolder_text">
                  {props.indivaction.business_name === undefined ||
                  props.indivaction.business_name === ""
                    ? "-"
                    : props.indivaction.business_name}
                </div>
              </div>
              <div className="col ms-2">
                <p className="text_st">Loan Reference No.</p>
                <div className="bolder_text">
                  {props.indivaction.loan_reference_no === undefined ||
                  props.indivaction.loan_reference_no === ""
                    ? "-"
                    : props.indivaction.loan_reference_no}
                </div>
              </div>
              <div className="col ms-2 me-2">
                <p className="text_st ">Loan Type</p>
                <div className="bolder_text ">
                  {props.indivaction.loan_type_name === undefined ||
                  props.indivaction.loan_type_name === ""
                    ? "-"
                    : props.indivaction.loan_type_name}
                </div>
              </div>
              <div className="col">
                <p className="text_st">Requested Tenure Period</p>
                <div className="bolder_text">
                  {" "}
                  {props.indivaction.admin_request_loan_tenure === undefined
                    ? "-"
                    : props.indivaction.admin_request_loan_tenure}{" "}
                  {props.indivaction.admin_request_loan_tenure === undefined ||
                  props.indivaction.admin_request_loan_tenure === ""
                    ? "-"
                    : props.indivaction.admin_request_loan_tenure === 1
                    ? " Month"
                    : " Months"}
                </div>
              </div>
            </div>
            <div className="row mt-4 mb-3">
              <div className="col-3">
                <p className="text_st">Amount Requested</p>
                <span className="bolder_text">
                  {props.indivaction.admin_request_loan_currency ===
                  LOAN_CURRENCY_TYPE_USD
                    ? "$\u00A0" +
                      Number(props.indivaction.loan_amount).toLocaleString()
                    : props.indivaction.admin_request_loan_currency ===
                      LOAN_CURRENCY_TYPE_BHD
                    ? LOAN_CURRENCY_TYPE_BHD +
                      " " +
                      Number(props.indivaction.loan_amount).toLocaleString()
                    : "-"}
                </span>
              </div>

              <div className="col loan_purpose_field">
                <p className="text_st">Loan Purpose</p>
                <div className="bolder_text">
                  {props.indivaction.loan_purpose === undefined ||
                  props.indivaction.loan_purpose === ""
                    ? "-"
                    : props.indivaction.loan_purpose}
                </div>
              </div>
            </div>
            <div className="row mb-1 mt-1">
              <div className="col">
                <p className="text_st view_inv_notes"> Notes</p>
                <div className="bolder_text  textarea-max-height">
                  {props.indivaction.notes === undefined ||
                  props.indivaction.notes === ""
                    ? "-"
                    : props.indivaction.notes}
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr />
        <div>
          <div className="row">
            <div className="col">
              <div className="row bg-white">
                <div className="col">
                  <div
                    className="nav-link newinvinterest active ps-0"
                    id="home-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#home-tab-pane"
                    type="button"
                    role="tab"
                    aria-controls="home-tab-pane"
                    aria-selected="true"
                  >
                    <h6 className="ps-0 ui_sch">Schedule Of Return Payments</h6>
                  </div>
                </div>
                <div className="newinvinteresttable-style">
                  <Table striped bordered hover>
                    <thead className="csv newinvinteresttable-headers">
                      <tr>
                        {headers.map((header, index) => (
                          <th
                            className=" text-center Cpointer"
                            key={header.sort}
                            onClick={() => handleSort(header.sort)}
                          >
                            {ltwo ? (
                              <Skeleton width={100} height={15} />
                            ) : header.title !== "Edit" ? (
                              <>
                                {" "}
                                {header.title}
                                &#9662;
                              </>
                            ) : (
                              header.title
                            )}
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody className="newinvinttable">
                      {schedules?.map((payment, index) => {
                        return (
                          <tr key={index}>
                            <td className="txt">
                              {payment.admin_request_loan_currency ===
                              LOAN_CURRENCY_TYPE_USD
                                ? "$\u00A0" +
                                  Number(payment.tenure_amount).toLocaleString()
                                : "BHD " +
                                  Number(
                                    payment.tenure_amount
                                  ).toLocaleString()}
                            </td>

                            <td className="txt">
                              {payment.is_selected == false ? (
                                moment(payment.tenure_date).format(
                                  "DD MMM YYYY"
                                )
                              ) : (
                                <DatePicker
                                  className="width_date_picker"
                                  showIcon
                                  onChange={(e) =>
                                    handleDateChange(
                                      e,
                                      payment.payment_schedule_id,
                                      index
                                    )
                                  }
                                  selected={
                                    new Date(
                                      moment(payment.tenure_date).format(
                                        "YYYY/MM/DD"
                                      )
                                    )
                                  }
                                />
                              )}
                            </td>
                            <td className="cursor-pointer txt">
                              <img
                                src={
                                  payment.color == "black"
                                    ? "./images/pen.svg"
                                    : "./images/yellow_edit.svg"
                                }
                                alt=""
                                onClick={() =>
                                  onPenClick(payment.payment_schedule_id)
                                }
                              />
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </Table>
                </div>
              </div>
            </div>{" "}
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="d-flex  ps-3 pe-3">
        <div>
          <button
            className="btn btn_background mx-2 px-3 py-2"
            onClick={handleClose}
          >
            Close
          </button>
          <button
            className="btn blue_btn mx-2 px-3 py-2"
            // disabled={activeTabBool}
            disabled={roleCode===AUDITOR_ROLE || activeTabBool}
            onClick={submitted}
          >
            Push To Business
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export const LoanDisbursement = (props) => {
  let loading = props.loading;
  const [activeButton, setActiveButton] = useState(true);
  const [activeTab, setActiveTab] = useState("profile-tab");

  const [schedules, setSchedulesData] = useState();
  const [selectedtype, setSelectedType] = useState();
  const [enteredamount, setEnteredAmount] = useState();
  const [paidDate, setPaidDate] = useState(null);
  const [comments, setComments] = useState();
  const received_via_names = [
    "Wire Transfer",
    "Paid from Bank Account",
    "Cash",
    "Cheque",
    "Others",
  ];
  let schedulesData = props.data?.payment_schedule;
  useEffect(() => {
    schedulesData?.map((element) => {
      element.is_selected = false;
      element.color = "black";
    });
    setSchedulesData(schedulesData);
  }, []);
  const handleClose = () => {
    props.onHide();
    setActiveButton(true);
    setActiveTab("profile-tab");

    schedules?.map((element) => {
      element.is_selected = false;
      element.color = "black";
    });
    setSchedulesData(schedulesData);
  };
  const onPenClick = (id) => {
    let sch = [...schedules];
    sch.map((ele) => {
      if (ele.payment_schedule_id === id) {
        ele.is_selected = true;
        ele.color = "yellow";
      } else {
        ele.is_selected = false;
        ele.color = "black";
      }
      setSchedulesData(sch);
    });
  };

  const handleDateChange = (e, id, index) => {
    let sch = [...schedules];
    let current_date = parseInt(
      Math.round(new Date(e).getTime() / 1000) + "000"
    );
    sch[index]["tenure_date"] = current_date;
    sch[index]["is_selected"] = false;
    sch[index]["color"] = "black";
    setSchedulesData(sch);
  };
  const radioButtonMethodRating = (e) => {
    setSelectedType(e.target.value);
  };
  // const handleChangeInput = (e) => {
  //   const target = e.target;
  //   const value = target.value;
  // };
  const handleChangeInputDate = (e) => {
    let datum = Date.parse(e.target.value);
    if (isNaN(datum)) {
      setPaidDate("");
      datum = "";
    } else {
      setPaidDate(datum);
    }
  };
  const handleChangeInputComments = (e) => {
    setComments(e.target.value);
  };

  const submitted = () => {
    if (props.data?.is_multi_investor) {
      toast.error("This loan is funded through Fund Now - disburse it from its Fund Now row", {
        toastId: 349,
      });
      return;
    }
    if (paidDate === null || enteredamount === null || selectedtype === null) {
      toast.error("Please fill out mandatory fields", {
        toastId: 3,
      });
    } else {
      let payment_data = {
        investor_id: props.data.investor_id,
        investor_interest_id: props.data.investor_interest_id,
        investor_request_id: props.data.investor_request_id,
        admin_user_id: Cookies.get("admin_user_id"),
        business_id: props.data.business_id,
        loan_id: props.data.loan_id,
        paid_date: paidDate,
        paid_amount: props.data.loan_amount,
        paid_currency: props.data.admin_request_loan_currency,
        paid_via: selectedtype,
        comments: comments,
        processing_fees: props.data.processing_fees,
        processing_fees_type: props.data.processing_fees_type,
        created_by: Cookies.get("admin_user_name"),
      };
      axios
        .post(
          base_url + "payment-to-business/save_payment_to_business",
          payment_data
        )
        .then((res) => {
          axios
            .post(
              base_url + "payment-schedules/update_payment_schedule",
              schedules
            )
            .then((res) => {
              if (res.data.status == 200) {
                toast.success("Success", {
                  toastId: 4,
                });
                props.onHide();

                setTimeout(() => {
                  window.location.reload();
                }, 800);
              }
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };
  const handleClicktab = () => {
    setActiveTab("home-tab");
    setEnteredAmount(props.data.loan_amount);
  };
  return (
    <Modal
      {...props}
      dialogClassName="modal-190w"
      aria-labelledby="example-custom-modal-styling-title"
      size="lg"
      backdrop="static"
      keyboard={false}
      centered
    >
      <Modal.Header onHide={handleClose} closeButton className="modal_title">
        <Modal.Title id="example-custom-modal-styling-title">
          <div className=" ps-2 d-flex justify-content-between">
            <div className="heading_new_loan ">
              <h5 className="mb-0 me-5 pe-5">Payment Details</h5>
            </div>
            <div className="head_threedots">
              <img src="./images/offerAccepted.svg" alt="" />
              <h5 className="green-title ">Offer Accepted</h5>
            </div>
          </div>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body
        className="px-4 py-2"
        style={{ height: "28rem", overflow: "auto" }}
      >
        <div className="container p-0 pb-2">
          <div className="row">
            <div className="col ">
              <div className="mb-3">
                <p className="text_st ">Loan Reference No.</p>
                <span className="bolder_text ">
                  {props.data.loan_reference_no}
                </span>
              </div>
              <div className="col">
                <div className="mb-3">
                  <p className="text_st ">Principal Frequency</p>
                  <span className="bolder_text ">
                    {props.data.principal_frequency}
                  </span>
                </div>
                <div className="mb-3">
                  <p className="text_st ">Processing Fee</p>
                  <span className="bolder_text ">
                    {" "}
                    {props.data.admin_request_loan_currency ===
                    LOAN_CURRENCY_TYPE_USD
                      ? "$\u00A0" + props.data.processing_fees
                      : "BHD " + props.data.processing_fees}
                  </span>
                </div>
              </div>
            </div>
            <div className="col-lg-5">
              <div className="mb-3">
                <p className="text_st ">Investor Reference No.</p>
                <span className="bolder_text ">
                  {props.data.investor_reference_no === "" ||
                  props.data.investor_reference_no === undefined
                    ? "-"
                    : props.data.investor_reference_no}
                </span>
              </div>
              <div className="mb-3">
                <p className="text_st ">Interest Frequency</p>
                <span className="bolder_text ">
                  {props.data.interest_frequency}
                </span>
              </div>
              <div className="mb-3 ">
                <p className="text_st ">Loan Purpose</p>
                <div className="bolder_text loanpurpose">
                  {props.data.loan_purpose}
                </div>
              </div>
            </div>
            <div className="col">
              <div className="mb-3">
                <p className="text_st ">Loan Amount</p>
                <span className="bolder_text ">
                  {props.data.admin_request_loan_currency ===
                  LOAN_CURRENCY_TYPE_USD
                    ? "$\u00A0" + Number(props.data.loan_amount).toLocaleString()
                    : "BHD " + Number(props.data.loan_amount).toLocaleString()}
                </span>
              </div>
              <div className="mb-3">
                <p className="text_st ">Processing Fee Type</p>
                <span className="bolder_text ">
                  {props.data.processing_fees_type === undefined
                    ? "-"
                    : props.data.processing_fees_type}
                </span>
              </div>
            </div>
          </div>
        </div>

        <div>
          <div className="row bg-white ">
            <div className="col ">
              <ul className="nav nav-tabs d-flex" id="myTab" role="tablist">
                <li className="nav-item" role="presentation">
                  <button
                    className={`nav-link p-0 me-3  admin_PD_tabs ${
                      activeTab === "profile-tab" ? "active" : ""
                    }`}
                    id="profile-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#profile-tab-pane"
                    type="button"
                    role="tab"
                    aria-controls="profile-tab-pane"
                    aria-selected="true"
                    onClick={() => setActiveTab("profile-tab")}
                  >
                    <h6>Payment Details and Schedules</h6>
                    {activeTab === "profile-tab" && (
                      <img
                        style={{ marginTop: "-48px" }}
                        src="./images/polygondown.svg"
                        alt=""
                      />
                    )}
                  </button>
                </li>

                <li className="nav-item" role="presentation">
                  <button
                    className={`nav-link admin_PD_tabs  p-0 ${
                      activeTab === "home-tab" ? "active" : ""
                    } `}
                    id="home-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#home-tab-pane"
                    type="button"
                    role="tab"
                    aria-controls="home-tab-pane"
                    aria-selected="false"
                    onClick={handleClicktab}
                  >
                    <h6>Record Payment</h6>
                    {activeTab === "home-tab" && (
                      <img
                        style={{ marginTop: "-48px" }}
                        src="./images/polygondown.svg"
                        alt=""
                      />
                    )}
                  </button>
                </li>
              </ul>
            </div>

            <div className="tab-content align-items-center " id="myTabContent">
              <div
                className="tab-pane fade show active allinv_rightmrk_paydetails mt-2 "
                id="profile-tab-pane"
                role="tabpanel"
                aria-labelledby="profile-tab"
                tabIndex="0"
              >
                <div>
                  <div className="row">
                    <div className="col">
                      <div className="row bg-white">
                        <div className="col">
                          <div
                            className="nav-link newinvinterest active ps-0"
                            id="home-tab"
                            data-bs-toggle="tab"
                            data-bs-target="#home-tab-pane"
                            type="button"
                            role="tab"
                            aria-controls="home-tab-pane"
                            aria-selected="true"
                          ></div>
                        </div>
                        <div className=" ">
                          {loading ? (
                            <Skeleton width={100} height={15} />
                          ) : schedules?.length ? (
                            <Table
                              striped
                              // bordered
                            >
                              <thead className="csv ">
                                <tr>
                                  <th className="txt">Profit Amount Payment</th>
                                  <th className="txt">Tenure Date</th>

                                </tr>
                              </thead>
                              <tbody className="">
                                {schedules?.map((payment, index) => {
                                  return (
                                    <tr key={index}>
                                      <td className="txt">
                                        {payment.admin_request_loan_currency ===
                                        LOAN_CURRENCY_TYPE_USD
                                          ? "$\u00A0"
                                          : "BHD "}
                                        {payment.tenure_amount}
                                      </td>
                                      <td className="txt">
                                        {payment.is_selected == false ? (
                                          moment(payment.tenure_date).format(
                                            "DD MMM YYYY"
                                          )
                                        ) : (
                                          <DatePicker
                                            className="width_date_picker"
                                            showIcon
                                            onChange={(e) =>
                                              handleDateChange(
                                                e,
                                                payment.payment_schedule_id,
                                                index
                                              )
                                            }
                                            selected={
                                              new Date(
                                                moment(
                                                  payment.tenure_date
                                                ).format("YYYY/MM/DD")
                                              )
                                            }
                                          />
                                        )}
                                      </td>
                                      {/* D4: tenure dates are read-only at disbursement; the schedule is
                                          re-dated from the disbursement date on the server. */}
                                    </tr>
                                  );
                                })}
                              </tbody>
                            </Table>
                          ) : (
                            <div className="text-center fs-3 text-muted mt-5">
                              No data found.
                            </div>
                          )}
                        </div>
                      </div>
                    </div>{" "}
                  </div>
                </div>
              </div>
              <div
                className="tab-pane fade mt-1"
                id="home-tab-pane"
                role="tabpanel"
                aria-labelledby="home-tab"
                tabIndex="0"
              >
                <div className="contianer  p-0 d-flex">
                  <div className="form-group mb-3 me-3 custm_input_styl">
                    <label htmlFor="paid_date">
                      <p>
                        Paid Date <span style={{ color: "red" }}>*</span>
                      </p>
                    </label>
                    <input
                      autoFocus
                      id="paid_date"
                      type="date"
                      className="form-control rounded custm_border payemnt_details_BS_form_conrtl"
                      onChange={handleChangeInputDate}
                      placeholder="DD MMM YYYY"
                    />
                  </div>

                  <div className="form-group mb-3 ">
                    <label htmlFor="bennefin">
                      <p>Paid Amount </p>
                    </label>
                    <InputGroup className="mb-3 payemnt_details_BS_form_conrtl">
                      <Form.Control
                        type="number"
                        className="rounded  shadow-ben px-3 amt_field_border"
                        id="bennefin"
                        name="bennefin"
                        required
                        role="presentation"
                        autoComplete="off"
                        disabled
                        placeholder={Number(
                          props.data.loan_amount
                        ).toLocaleString()}
                        // onChange={handleChangeInput}
                      />
                      <InputGroup.Text
                        className="paymnt_details_amt "
                        id="basic-addon2"
                      >
                        <p className="Payment_currency">
                          {props.data.admin_request_loan_currency ===
                          LOAN_CURRENCY_TYPE_USD
                            ? "$"
                            : "BHD"}
                        </p>
                      </InputGroup.Text>
                    </InputGroup>
                  </div>
                </div>

                <div>
                  <h3>
                    Processed Via <span style={{ color: "red" }}>*</span>
                  </h3>
                  <div className=" p-0 d-flex justify-content-between w-75">
                    {received_via_names?.map((element) => {
                      return (
                        <div key={element} className="admin_PD_radio_div row">
                          <label htmlFor={element}>
                            <input
                              className="PD_input_radio "
                              id={element}
                              type="radio"
                              value={element}
                              name="radio"
                              onClick={radioButtonMethodRating}
                            />
                            <span className="kyc_style_doc ps-2">
                              {element}
                            </span>
                          </label>
                        </div>
                      );
                    })}
                  </div>
                </div>

                <div>
                  <h3 className="mt-4">Comments</h3>
                  <Form>
                    <Form.Group
                      className="custm_textarea_styl "
                      controlId="floatingTextarea"
                    >
                      <Form.Control
                        size="sm"
                        className="ANLtextarea "
                        name="textarea"
                        as="textarea"
                        style={{ height: "50px", width: "95%" }}
                        rows={2}
                        placeholder="Please enter comments..."
                        onChange={handleChangeInputComments}
                      />
                    </Form.Group>
                  </Form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="d-flex  ps-3 pe-3">
        <div>
          <button
            className="btn btn_background mx-2 px-3 py-2"
            onClick={handleClose}
          >
            Close
          </button>
          <button
            className="btn blue_btn mx-3 px-4 py-2"
            disabled={
              paidDate === null ||
              paidDate === "" ||
              enteredamount === null ||
              selectedtype === null ||
              selectedtype === "" ||
              selectedtype === undefined
                ? true
                : false
            }
            onClick={submitted}
          >
            Save
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};
